import React from 'react';
import { FuelButton } from '@frete.com/fuel-react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import useAmplitude from '@hooks/useAmplitude';
import { ActionsPropsInterface } from './ActionsTypes';

function Actions({ onClose, onNewJourney }: ActionsPropsInterface) {
  const { amplitudeEvent } = useAmplitude();
  const nameEvent = 'journey_create_modal_success_button_clicked';

  return (
    <FuelFlex defaultProps={{ justifyContent: 'center', gap: 'km4' }}>
      <FuelButton
        data-testid="button-cancel"
        variant="tertiary"
        size="large"
        onClick={() => {
          amplitudeEvent(nameEvent, {
            source: 'close',
          });
          onClose();
        }}
      >
        Fechar
      </FuelButton>
      <FuelButton
        data-testid="button-done"
        size="large"
        onClick={() => {
          amplitudeEvent(nameEvent, {
            source: 'new-journey',
          });
          onNewJourney();
        }}
      >
        Nova viagem
      </FuelButton>
    </FuelFlex>
  );
}

export default Actions;
